import { render, staticRenderFns } from "./ActualitesVignetteIcon.vue?vue&type=template&id=434fe114"
import script from "./ActualitesVignetteIcon.vue?vue&type=script&lang=js"
export * from "./ActualitesVignetteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports